import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon, PlayIcon } from 'lucide-react';
interface Movie {
  id: string;
  title: string;
  thumbnail: string;
  duration: string;
  genre?: string;
  year?: string;
  rating?: string;
  progress?: number;
}
interface MovieRowProps {
  title: string;
  movies: Movie[];
  onPlayMovie: () => void;
  isMobile?: boolean;
}
const MovieCard = ({
  movie,
  onPlay,
  isMobile = false
}: {
  movie: Movie;
  onPlay: () => void;
  isMobile?: boolean;
}) => <div className={`relative flex-shrink-0 ${isMobile ? 'w-44' : 'w-64'} group`} data-id="element-394">
    <div className="relative overflow-hidden rounded-lg transition-transform duration-300 group-hover:scale-105 group-hover:ring-2 group-hover:ring-white" data-id="element-395">
      <img src={movie.thumbnail} alt={movie.title} className="w-full aspect-video object-cover" data-id="element-396" />
      {movie.progress && <div className="absolute bottom-0 left-0 right-0 h-1 bg-gray-600" data-id="element-397">
          <div className="h-full bg-red-600" style={{
        width: `${movie.progress}%`
      }} data-id="element-398" />
        </div>}
      <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-40 transition-opacity" data-id="element-399" />
      <div className="absolute bottom-0 left-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity transform translate-y-2 group-hover:translate-y-0" data-id="element-400">
        <div className="flex items-center justify-between mb-2" data-id="element-401">
          <button onClick={onPlay} className="bg-white rounded-full p-2 text-black hover:bg-opacity-90 transition-colors" data-id="element-402">
            <PlayIcon className="w-4 h-4" data-id="element-403" />
          </button>
          <span className="text-sm text-white" data-id="element-404">{movie.duration}</span>
        </div>
        <h3 className="text-white font-medium mb-1" data-id="element-405">{movie.title}</h3>
        <div className="flex items-center text-sm text-gray-300 space-x-2" data-id="element-406">
          {movie.rating && <span className="border px-1 text-xs" data-id="element-407">{movie.rating}</span>}
          {movie.year && <span data-id="element-408">{movie.year}</span>}
          {movie.genre && <span data-id="element-409">• {movie.genre}</span>}
        </div>
      </div>
    </div>
    {/* Mobile-specific title display */}
    {isMobile && <div className="mt-1" data-id="element-410">
        <h3 className="text-sm font-medium truncate" data-id="element-411">{movie.title}</h3>
        <div className="flex items-center text-xs text-gray-400" data-id="element-412">
          {movie.rating && <span className="mr-1" data-id="element-413">{movie.rating}</span>}
          {movie.year && <span data-id="element-414">{movie.year}</span>}
        </div>
      </div>}
  </div>;
export const MovieRow = ({
  title,
  movies,
  onPlayMovie,
  isMobile = false
}: MovieRowProps) => {
  return <div className="mb-8" data-id="element-415">
      <h2 className={`${isMobile ? 'text-xl' : 'text-2xl'} font-bold mb-4 px-0 md:px-4`} data-id="element-416">
        {title}
      </h2>
      <div className="relative group" data-id="element-417">
        <div className={`flex space-x-4 overflow-x-auto ${isMobile ? 'px-0' : 'px-8'} scrollbar-hide`} data-id="element-418">
          {movies.map(movie => <MovieCard key={movie.id} movie={movie} onPlay={onPlayMovie} isMobile={isMobile} data-id="element-419" />)}
        </div>
        {!isMobile && <>
            <button className="absolute left-0 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 p-4 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-420">
              <ChevronLeftIcon className="w-6 h-6" data-id="element-421" />
            </button>
            <button className="absolute right-0 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 p-4 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-422">
              <ChevronRightIcon className="w-6 h-6" data-id="element-423" />
            </button>
          </>}
      </div>
    </div>;
};